export default "__VITE_ASSET__BQJ_miYG__";